import { BaseModel } from './BaseModel';

export interface IUserModuleModelProps {
    id?: string;
    Id?: string;
    Modules: {
        DateCompleted: any;
        DueDate: any;
        TrainingDuration: any;
        ModuleName: string;
        ModuleId: string;
        Completed: number;
        CompletedDate: any;
        Expired: string;
        ParentId: string;
    }[];
    Name: string;
    modulesCount?: number;
    UserImage: string;
}

export class UserModuleModel extends BaseModel<IUserModuleModelProps> {
    constructor(props: IUserModuleModelProps) {
        super(props);
    }

    public static get(id: string) {
        return UserModuleModel.getSingleInstance<IUserModuleModelProps>(id);
    }

    public static list() {
        return UserModuleModel.listAll<IUserModuleModelProps>();
    }
    public static resource: string = 'user-module';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/UserModulesModel.ts